import { Accordion, AccordionItem, AccordionPanel, Box } from "@chakra-ui/react";
import { LoanContext } from "providers/loan";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext } from "react";
import DeleteLoanBtn from "./components/DeleteLoanBtn";
import LoanStatus from "components/loans/LoanStatus";
import AccordionTitle from "./components/AccordionTitle";
import StatusBadge from "components/elements/StatusBadge";
import LoanContacts from "components/loans/LoanContacts";
import ProofFundsCollapse from "components/elements/ProofFundsCollapse";
import VersionHistoryCollapse from "components/elements/VersionHistoryCollapse";
import { checkUiConfiguration } from "utils/uiconfighelper";

export const LoanSidebar = () => {
  const { loan } = useContext(LoanContext);
  const { user } = useTenant();

  return (
    <Box>
      <Accordion allowToggle={true}>
        <AccordionItem borderWidth={0}>
          <AccordionTitle
            title="Loan Status"
            description="View & update the current status of the loan."
            addon={<StatusBadge loan={loan} />}
            isFirst={true}
          />
          <AccordionPanel>
            <LoanStatus />
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <AccordionTitle
            title="Loan Contacts"
            description="View and manage contacts associated with this loan."
          />
          <AccordionPanel pb={4}>
            <LoanContacts />
          </AccordionPanel>
        </AccordionItem>

        {checkUiConfiguration(user, "proof_of_funds_enabled", true) && (
          <AccordionItem>
            <AccordionTitle
              title="Proof of Funds"
              description={
                user.type === "lender"
                  ? "Request proof of funds from the borrower."
                  : "Your lender may request proof of funds for this loan."
              }
            />
            <AccordionPanel>
              <ProofFundsCollapse />
            </AccordionPanel>
          </AccordionItem>
        )}

        {user.type === "lender" && (
          <AccordionItem>
            <AccordionTitle
              title="Version History"
              description="View all edits made to the loan."
            />
            <AccordionPanel>
              <VersionHistoryCollapse />
            </AccordionPanel>
          </AccordionItem>
        )}
      </Accordion>
      <DeleteLoanBtn id={loan!.id} />
    </Box>
  );
};
